import React from "react";
import './inputs.css';

const FileInput = (props) => {


    return (
        <div className="form-group">
            <label className="form-label">{props.label || "Select file"}</label>
            <div className="custom-file">
                <input
                    {...props}
                    type="file"
                    className="custom-file-input"
                    id="customFile"
                    onChange={props.onChange} />
                <label className="custom-file-label" htmlFor="customFile">{props.filename || "Choose file"}</label>
            </div>
        </div>
    );
};

export default FileInput;